import { RoutingConfig } from '@spartacus/core'
import { Routes } from '@angular/router'
import { CmsPageGuard, PageLayoutComponent } from '@spartacus/storefront'
import { MbCdcAuthGuard } from '../../auth/guards/mb-cdc-auth.guard'
import { MbGuestMyAccountPagesGuard } from '../../checkout/guards/guest-my-account-pages.guard'
import { OrderDetailsGuard } from '../../checkout/guards/order-details.guard'

export const mbAccountRoutingConfig: RoutingConfig = {
  routing: {
    routes: {
      myAccount: { paths: ['myaccount'] },
      myWishlist: { paths: ['myaccount/wishlist'] },
      mbOrders: { paths: ['myaccount/orders'] },
      addressbook: { paths: ['myaccount/address-book'] },
      mbOrderDetails: { paths: ['myaccount/order/:orderCode'],
                        paramsMapping: { orderCode: 'orderCode' } }
    }
  }
}

export const mbAccountRoutes: Routes = [
  {
    path: null as any,
    canActivate: [MbCdcAuthGuard, MbGuestMyAccountPagesGuard, CmsPageGuard],
    component: PageLayoutComponent,
    data: { cxRoute: 'myAccount' },
    pathMatch: 'full'
  },
  {
    path: null as any,
    canActivate: [MbCdcAuthGuard, MbGuestMyAccountPagesGuard, CmsPageGuard],
    component: PageLayoutComponent,
    data: { cxRoute: 'myWishlist' },
    pathMatch: 'full'
  },
  {
    path: null as any,
    canActivate: [MbCdcAuthGuard, MbGuestMyAccountPagesGuard, CmsPageGuard],
    component: PageLayoutComponent,
    data: { cxRoute: 'mbOrders' },
    pathMatch: 'full'
  },
  {
    path: null as any,
    canActivate: [MbCdcAuthGuard, MbGuestMyAccountPagesGuard, CmsPageGuard],
    component: PageLayoutComponent,
    data: { cxRoute: 'addressbook' },
    pathMatch: 'full'
  },
  {
    path: null as any,
    canActivate: [MbCdcAuthGuard, MbGuestMyAccountPagesGuard, CmsPageGuard, OrderDetailsGuard],
    component: PageLayoutComponent,
    data: { cxRoute: 'mbOrderDetails' },
  }
]
